<div class="modal-header">
  <h4 class="modal-title">{{ 'commentModal.modalHeader.title' | translate }}
    <span *ngIf="nom_cinema && liv_ville" class="modal-title"> : {{ liv_ville }} - {{ nom_cinema }}</span></h4>

  <button type="button" class="close" (click)="closeModal()">{{ 'commentModal.modalHeader.closeButton' | translate }}</button>
</div>
<div class="modal-body">
    <form #filmForm="ngForm" (ngSubmit)="saveComment()">
    <div *ngIf="comments.length > 0">
      <div *ngFor="let comment of comments" class="form-group">
        <div class="d-flex justify-content-between align-items-center">
          <span class="comment-text">
            {{ comment.date_debut }} - {{ comment.date_fin }} - {{ comment.commentaire }}
          </span>
          <button type="button" class="btn btn-link text-danger p-0 ml-2" (click)="deleteComment(comment.id_comm)">
            <i class="bi bi-x-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <ng-container *ngIf="comments.length === 0">
      <label>{{ 'commentModal.dateStart' | translate }}</label>
      <div class="form-group">
        <input
          class="form-control datepicker-input"
          [(ngModel)]="startDate"
          ngbDatepicker
          #startDp="ngbDatepicker"
          name="dateStart"
          required
          [firstDayOfWeek]="3"
        />
        <button
          class="btn btn-outline-secondary bi bi-calendar3"
          (click)="startDp.toggle()"
          type="button"
        >
        </button>
      </div>
      <label>{{ 'commentModal.dateEnd' | translate }}</label>
      <div class="form-group">
        <input
          class="form-control datepicker-input"
          [(ngModel)]="endDate"
          ngbDatepicker
          #endDp="ngbDatepicker"
          name="dateEnd"
          required
          [firstDayOfWeek]="3"
        />
        <button
          class="btn btn-outline-secondary bi bi-calendar3"
          (click)="endDp.toggle()"
          type="button"
        >
        </button>
      </div>
      <label>{{ 'commentModal.label' | translate }}</label>
      <div class="form-group">
        <textarea class="form-control" [(ngModel)]="comment" name="comment" required></textarea>
      </div>
      <div class="form-group">
      </div>
    </ng-container>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary validate-btn" (click)="filmForm.ngSubmit.emit()">{{ 'commentModal.saveButton' | translate }}</button>
</div>
